// Mirrors backend side_multipliers: the underdog side carries the whole-number
// multiplier; the favoured side pays 1x.
export function sideMultipliers(p) {
  p = Math.max(1, Math.min(99, Math.round(p)));
  const rh = (x) => Math.floor(x + 0.5);
  if (p <= 50) return { agree: rh(100 / p), disagree: 1 };
  return { agree: 1, disagree: rh(100 / (100 - p)) };
}

export function headlineMultiplier(p) {
  const { agree, disagree } = sideMultipliers(p);
  const side = agree >= disagree ? "agree" : "disagree";
  return { value: Math.max(agree, disagree), side };
}

// Mee Eens multiplier -> red, Mee Oneens multiplier -> green.
export function sideColor(side) {
  return side === "agree" ? "text-lie" : "text-truth";
}
